import { Box } from "@mui/material";
import { ColorsConstants } from "../cssUtils/constants";

const SidebarIcon = ({
  children,
  fontSize = "inherit",
  isActive = false,
  sx = {},
  sectionId,
  ...props
}) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize,
        width:
          sectionId === "chatbot"
            ? "65px"
            : fontSize === "inherit"
            ? "32px"
            : fontSize,
        height:
          sectionId === "chatbot"
            ? "50px"
            : fontSize === "inherit"
            ? "32px"
            : fontSize,
        padding: "6px",
        borderRadius: sectionId === "chatbot" ? 0 : 1,
        color: isActive ? "primary.main" : "#fff", 
        transition: "background-color 0.2s ease",

        "& svg": {
          width: "100%",
          height: "100%",
          // fill: "white",
          // color: "white",
          transition: "fill 0.2s ease",
        },

        "&:hover": {
          backgroundColor:
            sectionId === "chatbot"
              ? "transparent"
              : isActive
              ? ColorsConstants.primaryGray40
              : "#FFFFFF30",
        },

        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default SidebarIcon;